import React from 'react';

import { iframeLink } from 'core/iframe';
import { CorporateIndexView } from './page';
import * as Styled from './styles';

export function CorporateIndex(props) {
    const { vars } = props.useRankingCorporate;
    const { application, companyApplication } = vars;

    // Termo de Ciência completion: all 6 acknowledgement items checked
    // (now stored on Company.rankingData[ranking].rulesAcknowledgement)
    const ackKeys = [
        'realRelationships',
        'validatedByOtherParty',
        'officialPublicationRequiresAudit',
        'auditCost',
        'caseRequirement',
        'awardsOptional'
    ];
    const ack = companyApplication?.rulesAcknowledgement || {};
    const hasAllAcks = ackKeys.every(k => ack[k] === true);

    const auditConfirmed =
        companyApplication?.auditEnrollment?.status === 'confirmed';

    // Create the steps for this index
    const steps = [
        {
            step: 1,
            href: '/ranking/latam/corporate/step1',
            text: props.t('CorporateIndex.step1'),
            isBlocked: false,
            isCompleted: application?.steps?.step1 || false,
            isVisible: true
        },
        {
            step: 2,
            href: '/ranking/latam/corporate/step2',
            text: props.t('CorporateIndex.step2'),
            isBlocked: !application?.steps?.step1,
            isCompleted: application?.steps?.step2 || false,
            isVisible: true
        },
        {
            step: 3,
            href: '/ranking/latam/corporate/step3',
            text: props.t('CorporateIndex.step3'),
            isBlocked: !application?.steps?.step2,
            isCompleted: application?.steps?.step3 || false,
            isVisible: true
        },
        {
            step: 4,
            href: '/ranking/latam/corporate/step4',
            text: props.t('CorporateIndex.step4'),
            isBlocked: !application?.steps?.step3,
            isCompleted: application?.steps?.step4 || false,
            isVisible: true
        },
        {
            step: 5,
            href: '/ranking/latam/corporate/step5',
            text: props.t('CorporateIndex.step5'),
            isBlocked: !application?.steps?.step4,
            isCompleted: !!application?.steps?.step5,
            isVisible: true,
            ...(!application?.steps?.step5 && application?.steps?.step4 ? { icon: 'fas fa-exclamation-triangle', type: 'warning' } : {})
        },
        {
            step: 6,
            href: '/ranking/latam/corporate/step6',
            text: props.t('CorporateIndex.step6'),
            isBlocked: false,
            isCompleted: hasAllAcks,
            isVisible: true,
            ...(!hasAllAcks && application?.steps?.step4 ? { icon: 'fas fa-exclamation-triangle', type: 'warning' } : {})
        },
        {
            step: 7,
            href: '/ranking/latam/corporate/step7',
            text: props.t('CorporateIndex.step7'),
            isBlocked: !hasAllAcks,
            isCompleted: auditConfirmed,
            isVisible: true,
            ...(!auditConfirmed && hasAllAcks
                ? { icon: 'fas fa-exclamation-triangle', type: 'warning' }
                : {})
        }
    ];

    // Create a list for the support links
    const actions = [
        {
            id: 1,
            href: iframeLink('https://100os.net/ranking-sobre'),
            text: props.t('CorporateIndex.RankingAbout')
        },
        {
            id: 2,
            href: '/support',
            text: props.t('CorporateIndex.HelpAndSupport')
        }
    ];

    const propsView = { ...props, actions, steps };

    return (
        <Styled.CorporateIndex>
            <CorporateIndexView {...propsView} />
        </Styled.CorporateIndex>
    );
}
